import { useRef } from 'react';

export function usePrevious<T>(value: T) {
  const previousValue = useRef<T | undefined>(undefined);
  const currentValue = useRef<T>(undefined as unknown as T);

  previousValue.current = currentValue.current;
  currentValue.current = value;

  return previousValue;
}
